import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const PilotInfoContainer = styled.div<React.CSSProperties>`
  display: flex;
  position: absolute;
  bottom: ${30 * Screen.widthRatio}px;
  left: ${270 * Screen.widthRatio}px;
`;

export default PilotInfoContainer;
